export default "__VITE_ASSET__DSruVP8h__"